// packages/web-ui/src/AppShell/layout-storage.ts
//
// W2-S2 AC #2 — localStorage persistence for ContextPanel + UtilityDrawer
// widths, scoped under the `tessa-lean.layout.*` namespace.

const KEY_CONTEXT_PANEL = 'tessa-lean.layout.contextPanelWidth';
const KEY_UTILITY_DRAWER = 'tessa-lean.layout.utilityDrawerWidth';

function readNumber(key: string): number | null {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return null;
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

function writeNumber(key: string, value: number): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(key, String(Math.round(value)));
  } catch {
    // Storage may be full / disabled — silently ignore. The width is still
    // applied to the slice; only persistence is lost.
  }
}

export const layoutStorage = {
  readContextPanelWidth: (): number | null => readNumber(KEY_CONTEXT_PANEL),
  writeContextPanelWidth: (value: number): void => writeNumber(KEY_CONTEXT_PANEL, value),
  readUtilityDrawerWidth: (): number | null => readNumber(KEY_UTILITY_DRAWER),
  writeUtilityDrawerWidth: (value: number): void => writeNumber(KEY_UTILITY_DRAWER, value),
} as const;

export const LAYOUT_STORAGE_KEYS = {
  contextPanelWidth: KEY_CONTEXT_PANEL,
  utilityDrawerWidth: KEY_UTILITY_DRAWER,
} as const;
